// extracted by mini-css-extract-plugin
module.exports = {"nav":"Primary_nav__h0S30","active":"Primary_active__Oea1k","move":"Primary_move__rID3d"};